import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import { useTranslate } from "./TranslationText";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";

// Flutter API filter keys:
// newsTitle, newsCategory (From EAHS / About EAHS), newsClassification (General / Activities and events), newsDateFrom, newsDateTo

const initFilterState = {
  newsName: "",           // → API key: newsTitle
  newscategory: "",       // → API key: newsCategory  (empty = All)
  newsClassification: "", // → API key: newsClassification (empty = All)
  DateFrom: "",
  DateTo: "",
};

const NewsFilter = ({ onSubmit }) => {
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);
  const [filterState, setFilterState] = useState(initFilterState);

  const handleChange = (event, input) => {
    if (input === "DateFrom") {
      setDateStartFrom(event);
      setFilterState(prev => ({
        ...prev,
        DateFrom: event && event.$d ? event.$d.toISOString() : "",
      }));
      return;
    }
    if (input === "DateTo") {
      setDateStartTo(event);
      setFilterState(prev => ({
        ...prev,
        DateTo: event && event.$d ? event.$d.toISOString() : "",
      }));
      return;
    }
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFilterState(prev => ({ ...prev, [event.target.name]: value }));
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState);
  };

  const handleReset = () => {
    window.scrollTo(0, 0);
    setDateStartFrom(null);
    setDateStartTo(null);
    const cleared = { ...initFilterState };
    setFilterState(cleared);
    onSubmit(cleared);
  };

  return (
    <form className={filterCard} onSubmit={handleSubmit} onReset={handleReset}>
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>

      {/* Title */}
      <div className="mb-form-group">
        <NetaqInput
          name="newsName"
          label={translate("web.newsTitle", "News Title")}
          placeholder={translate("web.newsTitle", "News Title")}
          type="text"
          onChange={handleChange}
          value={filterState.newsName}
        />
      </div>

      {/* News Type (Category) — Flutter values: "From EAHS", "About EAHS" */}
      <div className="mb-form-group">
        <label>{translate("web.newsType", "News Type")}</label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name="newscategory"
            type="radio"
            value="From EAHS"
            checked={filterState.newscategory === "From EAHS"}
            label={translate("web.fromEAHS", "From EAHS")}
            onChange={handleChange}
          />
          <NetaqInput
            name="newscategory"
            type="radio"
            value="About EAHS"
            checked={filterState.newscategory === "About EAHS"}
            label={translate("web.aboutEAHS", "About EAHS")}
            onChange={handleChange}
          />
          <NetaqInput
            name="newscategory"
            type="radio"
            value=""
            checked={filterState.newscategory === ""}
            label={translate("web.all", "All")}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* News Classification — Flutter values: "General", "Activities and events" */}
      <div className="mb-form-group">
        <label>{translate("web.newsClassification", "News Classification")}</label>
        <div className="AuctionFilterRadioContainer">
          <NetaqInput
            name="newsClassification"
            type="radio"
            value="General"
            checked={filterState.newsClassification === "General"}
            label={translate("web.general", "General")}
            onChange={handleChange}
          />
          <NetaqInput
            name="newsClassification"
            type="radio"
            value="Activities and events"
            checked={filterState.newsClassification === "Activities and events"}
            label={translate("web.eventsAndActivities", "Events And Activities")}
            onChange={handleChange}
          />
          <NetaqInput
            name="newsClassification"
            type="radio"
            value=""
            checked={filterState.newsClassification === ""}
            label={translate("web.all", "All")}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Date Range */}
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name="DateFrom"
              type="date"
              label={<>{translate("web.date", "Date")} {translate("web.from", "From")}</>}
              onChange={handleChange}
              value={dateStartFrom}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name="DateTo"
              type="date"
              label={<>{translate("web.date", "Date")} {translate("web.to", "To")}</>}
              onChange={handleChange}
              value={dateStartTo}
              minDate={dateStartFrom}
            />
          </div>
        </div>
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            isButton
            classNames="btn-outline-secondary"
            type="reset"
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            type="submit"
          />
        </div>
      </div>
    </form>
  );
};

export default NewsFilter;
